// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"ca1ba135","931":"2616c26a"}[chunkId] + ".chunk.js";
};